import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import { ITestKitOrder, ITestKitOrderPayload, ITestKitOrderResume } from '../../entities/TestKitOrder/TestKitOrder.ts';

export class TestKitOrderApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/TestKitOrders`;

    public static apiUrls = {
        getTestKitOrders: `${TestKitOrderApi.baseApiUrl}`,
        getTestKitOrderById: `${TestKitOrderApi.baseApiUrl}/:id`,
        getTestKitOrdersNew: `${TestKitOrderApi.baseApiUrl}/New`,
        postTestKitOrder: `${TestKitOrderApi.baseApiUrl}`,
        putTestKitOrder: `${TestKitOrderApi.baseApiUrl}/:id`,
        deleteTestKitOrder: `${TestKitOrderApi.baseApiUrl}/:id`,
    };

    public static async getTestKitOrders(): Promise<ITestKitOrderResume[]> {
        return this.sendApiRequest<ITestKitOrderResume[]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getTestKitOrders,
        });
    }

    public static async getTestKitOrdersById(id: string): Promise<ITestKitOrder> {
        return this.sendApiRequest<ITestKitOrder>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getTestKitOrderById,
            data: undefined,
            id: id,
        });
    }

    public static async getTestKitOrdersNew(): Promise<ITestKitOrder> {
        return this.sendApiRequest<ITestKitOrder>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getTestKitOrdersNew,
        });
    }

    public static async postTestKitOrder(data: ITestKitOrderPayload): Promise<number> {
        return this.sendApiRequest<number>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.postTestKitOrder,
            data: data,
        });
    }

    public static async putTestKitOrder(id: string, data: ITestKitOrderPayload): Promise<number> {
        return this.sendApiRequest<number>({
            method: HttpMethodEnum.PUT,
            path: this.apiUrls.putTestKitOrder,
            data: data,
            id: id,
        });
    }

    public static async deleteTestKitOrder(id: string): Promise<void> {
        return this.sendApiRequest<void>({
            method: HttpMethodEnum.DELETE,
            path: this.apiUrls.deleteTestKitOrder,
            data: undefined,
            id: id,
        });
    }
}
